import DemoCard from '../DemoCard'
import { DemoSectionProps } from '../types'

const Medications = ({ triggerDemo }: DemoSectionProps ) => {
  const demos = [
    {
      demo: 'practiceMedicationsReset',
      isReset: true,
      buttonText: 'Reset All Medications Data',
      features: [
        'Removal All Medications'
      ]
    },
    {
      demo: 'practiceMedicationsDemo',
      isReset: false,
      buttonText: 'Prepare Medications Section for a Demo',
      features: [
        '1 SM27 AAS w/ upcoming shipments',
        '1 SM30 AAS w/ upcoming shipments'
      ]
    },
    {
      demo: 'practiceMedicationsMembership',
      isReset: false,
      buttonText: 'Membership',
      features: [
        '1 SM27 membership kit'
      ]
    },
    {
      demo: 'practiceMedicationsPo',
      isReset: false,
      buttonText: 'ARS(Automatic Replenishment Service)/PO',
      features: [
        '1 SM27 AAS w/ upcoming shipments (including kit location)',
        '1 SM30 ARS/PO w/ upcoming shipments'
      ]
    },
    {
      demo: 'practiceMedicationsFourInactive',
      isReset: false,
      buttonText: 'Four Inactive Kits',
      features: [
        '1 inactive SM27 expired (including kit location)',
        '1 inactive SM27 expiring',
        '1 inactive SM30 expired/expiring',
        '1 inactive MISC'
      ]
    },
    {
      demo: 'practiceMedicationsPoExpiringExpired',
      isReset: false,
      buttonText: 'ARS/PO with Expired/Expiring Items',
      features: [
        '1 SM27 ARS/PO expired with kit location',
        '1 SM27 ARS/PO expiring',
        '1 SM27 ARS/PO expired/expiring',
        '1 SM27 AAS expired backordered with kit location'
      ]
    },
    {
      demo: 'practiceMedicationsPendingApproval',
      isReset: false,
      buttonText: 'Pending Approval',
      features: [
        '1 SM27 PO pending approval'
      ]
    },
    {
      demo: 'practiceMedicationsExpiredRefill',
      isReset: false,
      buttonText: 'AAS with Expired Items Being Refilled Soon',
      features: [
        '1 SM27 AAS expired but refilled soon including kit location'
      ]
    },
    {
      demo: 'practiceMedicationsBackordered',
      isReset: false,
      buttonText: 'AAS (Advance Approval Services) Kit with Backordered Items',
      features: [
        '1 SM27 AAS (Advance Approval Services) expired',
        '1 SM27 AAS expiring',
        '1 SM27 AAS uptodate'
      ]
    },
    {
      demo: 'practiceMedicationsUnshipped',
      isReset: false,
      buttonText: 'AAS with Unshipped Item',
      features: [
        '1 SM27 AAS with unshipped item'
      ]
    },
    {
      demo: 'practiceMedicationsOnHold',
      isReset: false,
      buttonText: 'ARS with On Hold Item',
      features: [
        '1 SM27 ARS with 1 item on hold'
      ]
    },
    {
      demo: 'practiceMedicationsAll',
      isReset: false,
      buttonText: 'Lot of Kits',
      features: [
        '1 SM30 AAS (including kit location)',
        '1 SM30 AAS Expired (including kit location)',
        '1 SM30 AAS Expired w/ Upcoming shipment (including kit location)',
        '1 SM27 ARS/PO (including kit location)',
        '1 SM27 ARS (Automatic Replishment Service)/PO Expired',
        '1 SM27 ARS/PO Expiring',
        '1 SM27 ARS/PO Expired/Expiring',
        '1 SM27 Inactive',
        '1 SM27 Inactive Expired',
        '1 SM27 Inactive Expiring',
        '1 SM27 Inactive Expired/Expiring'
      ]

    }
  ]

  return (
    <DemoCard headerText='Medications' demos={demos} triggerDemo={triggerDemo} />
  )
}

export default Medications